import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Space,
  Input,
  Modal,
  Form,
  Select,
} from "antd";
import { message } from "../../components/antdMessageBridge";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import SliderUI from "../manifest/manifest-slide";
import CommonObj from "../../CommonObj";
import { Html5QrcodeScanType } from "html5-qrcode";
import {
  CloseCircleOutlined,
} from "@ant-design/icons";
import { getUTCDate } from "../../components/utcDate";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService, { removeSpaces } from "../../components/commonregex/regexService";
import validationService from "../../components/commonvalidation/validationService";
import { showManualEntryDisabledWarning } from "../../components/commonvalidation/manualEntryWarning";
import useFieldPermissions from "../../hooks/useFieldPermissions";

const { Option } = Select;

const BatchProcess = ({ onDataChange, onBatch }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [rejectionOptions, setRejectOptions] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { accessToken, isAuthenticated } = useAuthToken();
  const [reasonLoading, setReasonLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [errors, setErrors] = useState({});
  const [form1] = Form.useForm();
  const { roleUserId } = useAuth();
  const [regexLoaded, setRegexLoaded] = useState(false);
  const { isReadOnly } = useFieldPermissions("cuttingBatch");
  const lastBidKeyTimeRef = useRef(0);
  const clearBidTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(clearBidTimerRef.current);
    };
  }, []);

  const component = "batch"
  const [form, setForm] = useState({
    bid: "",
    title: "",
    author: "",
    publisher: "",
    isbN10: "",
    isbN13: "",
    bookPageCount: "",
    language: "",
    weight: "0.75",
    isbn: "",
    condition: "",
    usedCondition: "",
    content: "",
    bookFormat: "",
    eqComplexityLevel: "",
    rackAndShelf: "",
    rackShelf: "",
    comments: "",
    bidScanTime: "",
  });
  const [commentsvisible, setCommentsVisible] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [currentBidForComments, setCurrentBidForComments] = useState("");

  const [activeScanner, setActiveScanner] = useState(null);
  const [decodedResults, setDecodedResults] = useState([]);
  const [rackselfsubmitstatus, setrackselfsubmitstatus] = useState("");

  const submitAllBids = async () => {

    const commaSeparatedIds = selectedRowKeys.join(",");

    if (!commaSeparatedIds) {
      message.error('No rows selected.');
      return;
    }
    if (form.rackShelf.length === 0) {
      message.error("Rack and Shelf is required");
      return;
    }

    if (data.length === 0 && !form.bid.trim()) {
      message.error("No BID(s) to submit.");
      return;
    }

    let submissionData;

    if (commaSeparatedIds.length > 0) {
      const selectedRows = data.filter(item => selectedRowKeys.includes(item.bid));
      submissionData = {
        bidList: selectedRows.map(item => ({ bid: item.bid, bidScanTime: item.bidScanTime || "" })),
        processid: 3,
        createdBy: roleUserId,
        rackShelf: form.rackShelf || "",
      };
    } else {
      submissionData = {
        bidList: [{ bid: form.bid.trim(), bidScanTime: form.bidScanTime || "" }],
        processid: 3,
        createdBy: roleUserId,
        rackShelf: form.rackShelf || "",
      };
    }

    try {
      const baseUrl = CommonObj.Endpoints.BookOperatorSubmit;
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
        },
        body: JSON.stringify(submissionData),
      });

      if (response.ok) {
        if (rackselfsubmitstatus) {

          message.success(`Rack-Shelf location updated and Cutting Completed successfully. Books are ready for scanning`);
        }

        else {
          message.success(
            "Cutting Completed successfully. Books are ready for scanning."
          );
        }

      }

      setForm((prev) => ({ ...prev, bid: "", rackShelf:"" }));

      const selectedBids = commaSeparatedIds;
      const updatedData = data.filter(item => !selectedBids.includes(item.bid));
      setData(updatedData);
    } catch (error) {
      message.error(`Failed to save the data`);
    }
  };

  const [isDisabled, setIsDisabled] = useState(false);

const handleSubmitData = async (e) => {
  e.preventDefault();

  setIsDisabled(true); 

  const newErrors = {};

  if (data.length === 0) {
    message.warning("No values in table");
    setIsDisabled(false); 
    return;
  }

  try {
    if (selectedRowKeys.length > 0 && form.rackShelf && form.rackShelf.trim() !== "") {
      if (regexLoaded) {
        const validation = regexService.validateRackShelf(form.rackShelf.trim());
        if (!validation.isValid) {
          newErrors.rackShelf = "Input format invalid: No matching pattern found.";
          setErrors(newErrors);
          setIsDisabled(false); 
          return;
        }
      } else {
        const rackShelfSuccess = await submitRackshelf();
        form.rackShelf("")
        if (!rackShelfSuccess) {
          setIsDisabled(false);
          return;
        }
      }
    }

    await submitAllBids();
  } catch (error) {
    console.error("Submission failed:", error);
  } finally {
    setIsDisabled(false);
  }
};   

      useEffect(() => {
          const loadRegexPatterns = async () => {
              try {
                  await regexService.fetchRegexData(accessToken);
                  await validationService.fetchRegexData(accessToken);
                  setRegexLoaded(true);
              } catch (error) {
                  console.error("Failed to load regex patterns:", error);
              }
          };
  
           //if (accessToken) {
          loadRegexPatterns();
           //}
      }, [accessToken]);
      
  useEffect(() => {
    onBatch('batch');
    onDataChange(data);
  }, [data]);
  const handleManifestReject = async (key) => {
    const commaSeparatedIds = selectedRowKeys.join(",");
    let bids = selectedRecord.bid;

    try {
      const loadingKey = "rejecting";
      message.loading({ content: "Rejecting bid...", key: loadingKey });
      const endUTCTime = getUTCDate();
      const payload = {
        bid: bids,
        createdBy: roleUserId,
        rejectType: key.rejectionType,
        rejectComments: key.rejectionReason ? key.rejectionReason : "",
        rackandShelfId: form?.rackShelf,
        rejectRackandShelfId: key?.rejectRackShelf,

      };

      const myHeaders = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };

      const response = await fetch(CommonObj.Endpoints.CuttingReject, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      });

      if (response.ok) {

        const rejectedBids = bids.split(',').map(bid => bid.trim());
        const updatedData = data.filter(item => !rejectedBids.includes(item.bid));
        setData(updatedData);

        if (commaSeparatedIds) {
          setSelectedRowKeys([]);
        }

        message.success({
          content: "Bid rejected successfully!",
          key: loadingKey,
          duration: 2,
        });

        setIsModalVisible(false);
        form1.resetFields(['rejectionType']);
        form1.resetFields(['rejectionReason']);
      } else {
        message.error({
          content: "Failed to reject bid.",
          key: loadingKey,
          duration: 2,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error({
        content: "An error occurred. Please try again.",
        key: "rejecting",
        duration: 2,
      });
    }
  };


  const closeSlider = async () => {
    setCommentsVisible(false)
    const response = await fetch(CommonObj.Endpoints.GetComments, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pageNo: 1,
        pageSize: 10,
        search: currentBidForComments,
      }),
    });
    const respData = await response.json();
    setData(prevData =>
      prevData.map(item =>
        item.bid === currentBidForComments ? { ...item, commentsCount: respData[0]?.totalRows } : item
      )
    );
  }

  const openCommentsSlider = async (bid) => {
    if (!bid) {
      message.warning("Please enter BID before viewing comments.");
      return;
      }
      const bidError = validationService.validateBid(bid);
      if (bidError) {
          message.error(bidError);
          return;
      }

    setCurrentBidForComments(bid);
    try {
      const response = await fetch(CommonObj.Endpoints.GetComments, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageNo: 1,
          pageSize: 10,
          search: bid,
        }),
      });
      if (!response.ok) {
        throw new Error(`Status ${response.status}`);
      }
      const data = await response.json();
      setCommentsList(data || []);
      setCommentsVisible(true);
    } catch (error) {
      message.error(`Failed to fetch comments: ${error.message}`);
    }
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "odd-row" : "even-row";
  };

  const saveComment = async () => {
    if (!currentBidForComments.trim()) {
      message.warning("No BID selected for saving comments.");
      return;
    }
    if (!form.comments.trim()) {
      message.warning("Please enter a comment before saving.");
      return;
    }
    const payload = {
      bid: currentBidForComments,
      process: 3,
      status: 7,
      comments: form.comments,
      createdBy: roleUserId,
    };
    setLoad(true)
    try {
      const response = await fetch(CommonObj.Endpoints.InsertComments, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
        if (!response.ok) {
            const result = await response.json();

            const errorMessage = result.error || result.message || `Error ${response.status}`;
            throw new Error(errorMessage);
        }
      message.success("Comment saved successfully!");
      setForm((prev) => ({ ...prev, comments: "" }));

      openCommentsSlider(currentBidForComments);
    } catch (error) {
        message.error({ content: error.message, duration: 5 });
    } finally {
      setLoad(false)
    }
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
    form1.resetFields();
  };
  function filterUniqueScans(results) {
    const filteredResults = [];
    if (results.length === 0) {
      return filteredResults;
    }
    filteredResults.push(results[0]);
    for (let i = 1; i < results.length; ++i) {
      if (results[i].decodedText !== results[i - 1].decodedText) {
        filteredResults.push(results[i]);
      }
    }
    return filteredResults;
  }
  useEffect(() => { }, []);

  useEffect(() => {
    const uniqueResults = filterUniqueScans(decodedResults);
    if (uniqueResults.length > 0 && activeScanner) {
      const latestResult = uniqueResults[uniqueResults.length - 1];
      const scannedValue = latestResult.decodedText;

      // Handle BID field specifically - append instead of replace
      if (activeScanner === "BID") {
        setForm((prev) => {
          const currentBid = prev.bid ? prev.bid.trim() : "";
          const newBid = currentBid ? `${currentBid}, ${scannedValue}` : scannedValue;
          return { ...prev, bid: newBid };
        });
      } else {
        setForm((prev) => {
          return { ...prev, [activeScanner.toLowerCase()]: scannedValue };
        });
      }

      setActiveScanner(null);
      setDecodedResults([]);
    }
  }, [decodedResults, activeScanner]);

  const onNewScanResult = (decodedText, decodedResult) => {
    setDecodedResults((prev) => [...prev, decodedResult]);
  };
    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);

        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText;

            switch (activeScanner) {
                case "Rack & Shelf ID":
                    form1.setFieldsValue({
                        rejectRackShelf: scannedValue,
                    });
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

   const fetchRejectionData = async (record) => {
    setLoading(true);
    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };
const formData = new FormData();
formData.append('statusName', 'Cutting - Reject');
const response = await fetch(CommonObj.Endpoints.GetRejectReasonsMaster, {
    method: 'POST',
    headers: myHeaders, 
    body: formData      
});
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      const books = Array.isArray(result) ? result : [result];
      const formattedData = books.map((item) => ({
        ...item,
        key: item.referenceId,
      }));
      setRejectOptions(formattedData);
      setSelectedRecord(record);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const showRejectModal = (record) => {

    fetchRejectionData(record);
    setSelectedRecord(record.bid);
    setSelectedRowKeys([record.bid]);
    setIsModalVisible(true);

  };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsDisabled(true); // Disable the button immediately

        setTimeout(() => {
            setIsDisabled(false);
        }, 3000); // 3000 milliseconds = 3 seconds

        const trimmedBid = form.bid.trim();

        if (!trimmedBid) {
            message.error("Please enter or scan a BID.");
            return;
        }

        // Parse, clean, filter, and REMOVE DUPLICATES using a Set
        const bidArray = [...new Set(
            trimmedBid
                .split(',')
                .map(bid => bid.trim())
                .filter(bid => bid.length > 0)
        )];

        if (bidArray.length === 0) {
            message.error("Please enter valid BID(s).");
            return;
        }

        if (bidArray.length > 1) {
            message.loading({ content: `Processing ${bidArray.length} unique BID(s)...`, key: 'processingBids' });

            let successCount = 0;
            let failCount = 0;

            const results = await Promise.allSettled(
                bidArray.map(bid => UserLogin(bid))
            );

            results.forEach((result) => {
                if (result.status === 'fulfilled' && result.value === true) {
                    successCount++;
                } else {
                    failCount++;
                }
            });

            message.destroy('processingBids');

            if (successCount > 0) {
                message.success(`${successCount} BID(s) added successfully!`);
            }
            if (failCount > 0) {
                message.warning(`${failCount} BID(s) failed to add.`);
            }

            setForm((prev) => ({ ...prev, bid: "" }));

        } else {
            await UserLogin(bidArray[0]);
            setForm((prev) => ({ ...prev, bid: "" }));
        }
    };

  const columns = [
    {
      title: "BID No",
      dataIndex: "bid",
      key: "bid",
      width: 200,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 220,
    },
    {
      title: "Status",
      dataIndex: "statusText",
      key: "statusText",
      width: 200,
    },
    {
      title: "Book Format",
      dataIndex: "format",
      key: "format",
      width: 200,
    },
    {
      title: "No of Pages",
      dataIndex: "pageCount",
      key: "pageCount",
      width: 150,
    },

    {
      title: "Language",
      dataIndex: "language",
      key: "language",
      width: 150,
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      width: 150,
    },
    {
      title: "Actions",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          {/* Render icons only if status is 'TBI' for conditional actions */}


          <div className="grid-comments-button-container">
            <button className="comments-header-status-notification"
              data-track="cutting-batch-view-comments"
              onClick={() => openCommentsSlider(record.bid)}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.15 6.69802L15.5362 6.31182C16.1761 5.67194 17.2135 5.67194 17.8534 6.31182C18.4933 6.95169 18.4933 7.98914 17.8534 8.62902L17.4672 9.01522M15.15 6.69802C15.15 6.69802 15.1983 7.51869 15.9224 8.24282C16.6466 8.96694 17.4672 9.01522 17.4672 9.01522M15.15 6.69802L11.5995 10.2485C11.359 10.489 11.2388 10.6093 11.1354 10.7418C11.0134 10.8982 10.9088 11.0675 10.8235 11.2465C10.7511 11.3983 10.6974 11.5596 10.5898 11.8823L10.2455 12.9152L10.1341 13.2494M17.4672 9.01522L13.9167 12.5657C13.6762 12.8062 13.556 12.9265 13.4234 13.0299C13.267 13.1519 13.0978 13.2564 12.9187 13.3418C12.767 13.4141 12.6056 13.4679 12.283 13.5754L11.25 13.9198L10.9158 14.0312M10.9158 14.0312L10.5816 14.1426C10.4228 14.1955 10.2478 14.1542 10.1294 14.0358C10.0111 13.9175 9.96976 13.7424 10.0227 13.5836L10.1341 13.2494M10.9158 14.0312L10.1341 13.2494" stroke="#002449" />
                <path d="M6.66797 10.8319H8.7513" stroke="#002449" strokeLinecap="round" />
                <path d="M6.66797 7.49988H12.0846" stroke="#002449" strokeLinecap="round" />
                <path d="M6.66797 14.1678H7.91797" stroke="#002449" strokeLinecap="round" />
                <path opacity="0.5" d="M2.5 8.33451C2.5 5.19182 2.5 3.62047 3.47631 2.64416C4.45262 1.66785 6.02397 1.66785 9.16667 1.66785H10.8333C13.976 1.66785 15.5474 1.66785 16.5237 2.64416C17.5 3.62047 17.5 5.19182 17.5 8.33451V11.6678C17.5 14.8105 17.5 16.3819 16.5237 17.3582C15.5474 18.3345 13.976 18.3345 10.8333 18.3345H9.16667C6.02397 18.3345 4.45262 18.3345 3.47631 17.3582C2.5 16.3819 2.5 14.8105 2.5 11.6678V8.33451Z" stroke="#002449" />
              </svg>

            </button>
            <span className="comments-header-status-notification-count">{record.commentsCount}</span>
          </div>


          <CloseCircleOutlined
            style={{
              color: "#EF4444", backgroundColor: "#FFEEEC", cursor: "pointer"
            }}
            data-track="cutting-batch-open-reject"
            onClick={() => showRejectModal(record)}
          />



          {record.status === 18 && (

            <CloseCircleOutlined
              style={{
                color: "#EF4444", backgroundColor: "#FFEEEC", cursor: "not-allowed"
              }}
            />

          )}
        </Space>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    }
  };
  async function UserLogin(bid) {

    const isBookInTable = data.some((item) => item.bid === bid);

    if (isBookInTable) {
      message.warning(`BID already exists. Please enter (or) scan the correct BID number`);
      return false;
    }
    setLoading(true);

    try {
      const bidfetch = await fetchBIDStatus(bid);

      if (bidfetch.trim() === '') {
        return; // Exit if it is an empty string
      }
      else {
        bid = bidfetch;
      }
      let pageName = {
        bid: bid,
        createdBy: roleUserId,
      };

        const response = await fetch(CommonObj.Endpoints.GetBookByBIDBatch, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(pageName),
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const result = await response.json();

      if (result && result.length > 0) {
        const bookData = result[0];

        setData((prevData) => [...prevData, { ...bookData, key: bookData.id }]);

        setForm((prevForm) => ({
          ...prevForm,
          bid: bookData.bid || prevForm.bid,
          title: bookData.title,
          author: bookData.author,
          publisher: bookData.publisher,
          isbN10: bookData.isbN10,
          isbN13: bookData.isbN13,
          bookPageCount: bookData.pageCount,
          language: bookData.language,
          weight: bookData.weight || "0.75",
          isbn: bookData.isbn || prevForm.isbn,
          bookFormat: bookData.format || prevForm.bookFormat,
          condition: bookData.condition || prevForm.condition,
          eqComplexityLevel:
            bookData.eqComplexityLevel || prevForm.eqComplexityLevel,
          content: bookData.content || prevForm.content,
          rackAndShelf: bookData.rackShelf || prevForm.rackShelf,
          bidScanTime: bookData.bidScanTime || "",
        }));

        return true;
      } else {
        message.error(`Invalid BID: ${bid}`);
        return false;
      }
    } catch (error) {
      console.error(error.message);
      message.error(`Failed to fetch book data for BID ${bid}: ${error.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  }


  const fetchBIDStatus = async (bid) => {
    const url = CommonObj.Endpoints.GetBatchBIDStatus;

    const requestData = {
      bid: bid,
      createdBy: roleUserId,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const errorResponse = await response.json();
        if (errorResponse.message) {
          message.info(errorResponse.message);
          return errorResponse.bids;
        }
        else { return errorResponse.bids; }
      }

      return "";
    } catch (error) {
      return "";
    }
  };


  const submitRackshelf = async () => {



    if (data.length === 0) {
      return false;
    }

    const submissionData = {
      bid: data.map((item) => item.bid).join(","),
      rackandShelfId: form.rackShelf,
      createdBy: roleUserId,
    };

    try {
      const baseUrl = CommonObj.Endpoints.SaveRackandShelf;
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submissionData),
      });

      if (response.ok) {
        setrackselfsubmitstatus(true);
        
        setForm((prev) => ({ ...prev, rackShelf: "" }));
        return;
      }
    } catch (error) {
      message.error(`Error submitting rack-shelf location`);
      console.error("Error submitting rack-shelf:", error);
      return false;
    }
  };

    function cusfun(e) {
        e.preventDefault();
    }
        const validateRackShelf = (_, value) => {
            if (!value) {
                return Promise.reject(new Error("Rack and Shelf is required."));
            }
            if (value && removeSpaces(value).toLowerCase() === removeSpaces(form.rackAndShelf).toLowerCase()) {
                return Promise.reject(
                    new Error("Books sent for rework cannot be placed in the same rack. Please scan the new rack.")
                );
            }
            if (value && regexLoaded) {
                const validation = regexService.validateRackShelf(value.trim());
                if (!validation.isValid) {
                    return Promise.reject(
                        new Error("Input format invalid: No matching pattern found.")
                    );
                }
            }
    
            return Promise.resolve();
        };
  return (
    <>
      <Modal
        title={`Scan ${activeScanner ? activeScanner : ""}`}
        open={!!activeScanner}
        onCancel={() => setActiveScanner(null)}
        footer={null}
        destroyOnClose
        width={1000}
        className="scan-model-container"
      >
        <div className="scan-modal">
          <Html5QrcodePlugin
            fps={30}
            qrbox={{ width: 1000, height: 400 }}
            aspectRatio={2.8}
            disableFlip={false}
            qrCodeSuccessCallback={onNewScanResult}
            supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
          />
        </div>
      </Modal>
      <SliderUI
        visible={commentsvisible}
        width={390}
        title="Comments Slide"
        onClose={() => closeSlider()}
        bookTitle={`Comments For BID : ${currentBidForComments}`}
        commentsList={commentsList}
        username={form.createdBy}
        form={form}
        setForm={setForm}
        saveComment={saveComment}
        load={load}
        commentsCount={commentsList.length}
        batchData={data}
        className="story-slider comment-slider-drawer-1"
      />

      <div className="book-page-form">
        <div className="book-page-camera-button-container multiple">
          <Input
            placeholder=""
            value={form.bid}
            className={`${form.bid ? "has-id" : ""}`}
            onChange={(e) => setForm({ ...form, bid: e.target.value })}
            onKeyDown={(e) => {
              if (!isReadOnly("bid")) {
                return;
              }

              // Let native copy/paste behave normally (no custom clipboard handling).
              const isCopyOrPasteShortcut =
                (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
              if (isCopyOrPasteShortcut) {
                return;
              }

              if (e.key === 'Enter' || e.key === 'Tab') {
                return;
              }

              const currentTime = Date.now();
              const timeDiff = currentTime - lastBidKeyTimeRef.current;
              lastBidKeyTimeRef.current = currentTime;

              // A physical scanner sends characters within a few milliseconds of each
              // other, so only block keystrokes that arrive slowly (manual typing).
              // The very first keystroke (field currently empty) is always let through
              // so a scan burst never loses its first character.
              const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
              if (!isSlowManualKeystroke) {
                return;
              }

              e.preventDefault();
              setForm((prev) => ({ ...prev, bid: '' }));

              clearTimeout(clearBidTimerRef.current);
              clearBidTimerRef.current = setTimeout(() => {
                showManualEntryDisabledWarning();
              }, 300);
            }}
            onPressEnter={handleSubmit}
            id="cutting-batch-bid-input-id"
            disabled={loading}
          />
          {form.bid.length === 0 && (
            <label htmlFor="cutting-batch-bid-input-id">
               {isReadOnly("bid") ? "Scan " : "Enter / Scan "}BID Number Using “<strong>Camera Icon</strong>”<span className="form-required">*</span>
            </label>
          )}
          <button
            type="button"
            className="book-page-camera-button"
            data-track="cutting-batch-open-bid-scanner"
            onClick={() => setActiveScanner("BID")}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="13"
                r="3"
                stroke="#1C274C"
                strokeWidth="1.5"
              />
              <path
                opacity="0.5"
                d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                stroke="#1C274C"
                strokeWidth="1.5"
              />
              <path
                d="M18 10H17.5"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                opacity="0.5"
                d="M14.5 3.5H9.5"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                fill="url(#paint0_linear_273_6917)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                fill="url(#paint1_linear_273_6917)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_273_6917"
                  x1="22.601"
                  y1="11.9503"
                  x2="1.98296"
                  y2="14.3301"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_273_6917"
                  x1="22.601"
                  y1="11.9503"
                  x2="1.98296"
                  y2="14.3301"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            type="button"
            className="book-page-camera-button-input-2"
            data-track="cutting-batch-add-bid"
            onClick={handleSubmit}
            disabled={isDisabled}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                fill="url(#paint0_linear_1900_8687)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1900_8687"
                  x1="20.6"
                  y1="9.94475"
                  x2="-0.0696504"
                  y2="12.0919"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
              </defs>
            </svg>
          </button>
        </div>

        {/* <div className="submit-button-container">
          <Button type="primary" onClick={handleSubmit}>
            Add
          </Button>
        </div> */}
      </div>
      <div className="table-container">
        <div className="rounded-table-wrapper">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={data}
            className="common-grid cutting-batch-processing comments-grid"
            pagination={false}
            rowKey={(record) => record.bid}
            scroll={{ x: "max-content", y: "calc(100vh - 455px)" }}
            rowClassName={getRowClassName}
          />
        </div>
        <Modal
          title={`Reject BID`}
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null} // Remove default footer to use form's submit button
        >
          <Form
            form={form1}
            layout="vertical"
            onFinish={handleManifestReject}
            initialValues={{ bid: selectedRecord?.bid }}
          >
            <Form.Item
              name="bid"
              label="Bid ID"
              hidden // This field can be hidden since the user doesn't need to change it
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="rejectionType"
              label="Reject Reason"
              rules={[
                { required: true, message: "Please select a rejection type!" },
              ]}
            >
              {/*<Select placeholder="Select a reason type">*/}
              {/*    <Option value="High Cost">High Cost</Option>*/}
              {/*    <Option value="Incomplete Info">Incomplete Information</Option>*/}
              {/*    <Option value="Out of Scope">Out of Scope</Option>*/}
              {/*</Select>*/}
              <Select
                placeholder="Select a Reason"
                loading={reasonLoading} // Use the loading state here
                notFoundContent="No Rejection Reasons Available"
              >
                {rejectionOptions?.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.reason}
                  </Option>
                ))}
              </Select>
            </Form.Item>
                        <div className="book-page-form-scan-rack-container modal-scan-rack  bgColor span2column">
                            <Form.Item
                                name="rejectRackShelf"
                                rules={[
                                    {
                                        validator: validateRackShelf,
                                    },
                                ]}
                                className="book-page-form-scan-rack-button"
                            >
                                <Input placeholder="Enter / Scan Rack Shelf Barcode"></Input>
                            </Form.Item>
                            <Form.Item name="submit" hidden></Form.Item>
                            <button
                                className="book-page-form-scan-rack-button-icon"
                              data-track="cutting-batch-reject-open-rack-scanner"
                                htmlType="submit"
                                onClick={(event) => {
                                    setDecodedResults([]);
                                    setActiveScanner("Rack & Shelf ID");
                                    cusfun(event);
                                }}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="20"
                                    height="18"
                                    viewBox="0 0 20 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6.00098 1C6.00098 0.447715 6.41425 0 6.92405 0H13.0779C13.5877 0 14.001 0.447715 14.001 1C14.001 1.55228 13.5877 2 13.0779 2H6.92405C6.41425 2 6.00098 1.55228 6.00098 1Z"
                                        fill="url(#paint0_linear_2146_40101)"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M7.77875 18H12.2232C15.3442 18 16.9047 18 18.0257 17.2777C18.511 16.965 18.9277 16.5632 19.252 16.0953C20.001 15.0143 20.001 13.5095 20.001 10.4999C20.001 7.49027 20.0008 5.9857 19.2518 4.90473C18.9275 4.43676 18.5109 4.03497 18.0256 3.72228C16.9046 3 15.3441 3 12.223 3H7.77859C4.65756 3 3.09705 3 1.97605 3.72228C1.49077 4.03497 1.0741 4.43676 0.749835 4.90473C0.000976503 5.98547 0.000976526 7.48961 0.000976563 10.4979L0.000976563 10.4999C0.000976563 13.5095 0.000976622 15.0143 0.750001 16.0953C1.07426 16.5632 1.49093 16.965 1.97622 17.2777C3.09721 18 4.65773 18 7.77875 18ZM5.83431 10.4999C5.83431 8.28085 7.69979 6.48196 10.001 6.48196C12.3022 6.48196 14.1676 8.28085 14.1676 10.4999C14.1676 12.7189 12.3022 14.5178 10.001 14.5178C7.69979 14.5178 5.83431 12.7189 5.83431 10.4999ZM7.50098 10.4999C7.50098 9.16846 8.62027 8.08913 10.001 8.08913C11.3817 8.08913 12.501 9.16846 12.501 10.4999C12.501 11.8313 11.3817 12.9106 10.001 12.9106C8.62027 12.9106 7.50098 11.8313 7.50098 10.4999ZM16.1121 6.48196C15.6519 6.48196 15.2788 6.84174 15.2788 7.28554C15.2788 7.72935 15.6519 8.08913 16.1121 8.08913H16.6676C17.1279 8.08913 17.501 7.72935 17.501 7.28554C17.501 6.84174 17.1279 6.48196 16.6676 6.48196H16.1121Z"
                                        fill="url(#paint1_linear_2146_40101)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_2146_40101"
                                            x1="20.601"
                                            y1="8.95028"
                                            x2="-0.0170404"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_2146_40101"
                                            x1="20.601"
                                            y1="8.95028"
                                            x2="-0.0170404"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <span className="error-msg-rad"></span>
                        </div>
            <Form.Item className="model-action-container">
              <Space>
                <button
                  className="ant-btn ant-btn-default slider-clear-button"
                  type="button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button className="ant-btn ant-btn-primary accept-button" data-track="cutting-batch-reject-submit" type="submit">
                  Submit
                </button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
      <div className="cutting-batch-footer-container">
        <h4>Cutting Batch Processing - {data?.length} Items</h4>
        <div>
        <div className="cutting-batch-footer-location-container">
          <label htmlFor="newrackself-location-cuttingbatch-id">
            New Rack-Self Location <span className="form-required">*</span><br />
            <span>(Applies to all Items)</span>
          </label>

          <input
            placeholder="Enter here" id="newrackself-location-cuttingbatch-id"
            value={form.rackShelf}
            onChange={(e) => { setForm({ ...form, rackShelf: e.target.value }); setErrors({}); }}
          />
        </div>
                        <span className="error-msg-cutting">{errors.rackShelf}</span>
</div>
      </div>
      {/* <button onClick={submitRackshelf}>New Rack Shelf location</button>{" "} */}
      {/* <div className="">
        <a href="javascript:void(0)" className="queue-link">
          &larr; Queue Page
        </a>
        <div className="footer-buttons">
          <button className="btn btn-clear">Clear</button>
          <button
            type="submit"
            className="btn btn-submit"
            onClick={handleSubmitData}
          >
            Submit
          </button>
        </div>
      </div> */}
      <div className="book-page-footer-container">
        <div className="book-page-action-container">
          <p className="book-page-action-note">
            <span>
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  opacity="0.7"
                  cx="7.99967"
                  cy="8.49967"
                  r="6.66667"
                  stroke="#009DDB"
                />
                <path
                  d="M8 11.833V7.83301"
                  stroke="#0009E2"
                  strokeLinecap="round"
                />
                <circle
                  cx="0.666667"
                  cy="0.666667"
                  r="0.666667"
                  transform="matrix(1 0 0 -1 7.33301 6.5)"
                  fill="#0009E2"
                />
              </svg>
            </span>
            BID Scanned Successfully - {data?.length}
            <span></span>
          </p>
          <div className="book-page-buttons-container">
            {/*<button*/}
            {/*  type="button"*/}
            {/*  class="reject-button" hidden*/}
            {/*  // onClick={handleClear}*/}
            {/*>*/}
            {/*  Clear*/}
            {/*</button>*/}
            <button className="accept-button" data-track="cutting-batch-submit" disabled={isDisabled} onClick={handleSubmitData}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BatchProcess;
